import { render, staticRenderFns } from "./DashboardDokterPage.vue?vue&type=template&id=52fdc150&"
import script from "./DashboardDokterPage.vue?vue&type=script&lang=ts&"
export * from "./DashboardDokterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
